<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar/>
      <main class="main">
        <breadcrumb :list="list" v-if="isDisplay"/>
        <div class="container-fluid" :class="!isDisplay ? 'noPadding': ''">
          <router-view :rootMethods="mappingObj"></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
//import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import CryptoJS from 'crypto-js';
import axios from 'axios';
import apiUrl from '../constants';
import GetMappings from '../Mappings/getCommonFunctionMaps';

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
  //    nav: nav.items
        mapping: {},
        GetMappingObj: {},
        isDisplay: false
    }
  },
  created(){
    var userToken = window.localStorage.getItem('accessuserToken');
    this.GetMappingObj = new GetMappings(userToken);
  },
  mounted() {
    if(this.$route.matched.length > 0) {
        this.isDisplay = !this.$route.matched.some(route => route.path === '/summerPage');
    }
  },
  watch: {
   '$route.matched'(matched) {
      // Check if any route's path matches '/summerPage'
      this.isDisplay = !matched.some(route => route.path === '/summerPage');
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      let t2 = new Date().setHours(new Date().getHours());
      if(window.localStorage.getItem('logoutTime') && window.localStorage.getItem('logoutTime') < t2){
        this.logout();
      }else{
        return this.$route.matched
      }
    }
  },
  methods: {
  logout() {
       localStorage.removeItem('accesshubdata')
       localStorage.removeItem('accesspermissiondata')
       localStorage.removeItem('accessuserdata')
       localStorage.removeItem('accessuserToken')
       localStorage.removeItem('isLoggedIn')
       localStorage.removeItem('logoutTime')
       localStorage.removeItem('accessrole')
       this.$router.push('/login');

   },
   async mappingObj(){
      this.mapping = await this.GetMappingObj.createMapping();
      return await this.mapping;
   }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Full.vue?be9bac1a